<template>
  <DocumentList
    :attachments="[document]"
    small/>
</template>
<script>
import DocumentList from 'components/common/blocks/DocumentList.vue'

import { TenderFile } from '@/types/commonFile.js'

export default {
  name: 'eventHistoryDocument',
  data() {
    return {}
  },
  methods: {},
  computed: {
    document() {
      return new TenderFile(
        this.$route.params.id,
        this.value.DocumentId,
        this.value.Key,
        null,
        this.value.Title,
        null,
        this.value.AttachmentType)
    },
  },
  components: {
    DocumentList
  },
  created() {},
  props: {
    value: {
      type: Object
    }
  },
}
</script>
<style scoped lang="scss">
</style>
